import React from "react";
import * as Components from "antd";

// Backwards-compatible Popconfirm wrapper: maps deprecated props to AntD v5 equivalents
export default (props: any) => {
  const {
    visible,
    defaultVisible,
    onVisibleChange,
    open: openProp,
    defaultOpen: defaultOpenProp,
    onOpenChange: onOpenChangeProp,
    ...rest
  } = props;

  const open = typeof openProp !== "undefined" ? openProp : visible;
  const defaultOpen =
    typeof defaultOpenProp !== "undefined" ? defaultOpenProp : defaultVisible;
  const onOpenChange =
    typeof onOpenChangeProp !== "undefined"
      ? onOpenChangeProp
      : onVisibleChange;

  return (
    <Components.Popconfirm
      {...rest}
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      destroyTooltipOnHide
      arrowPointAtCenter
      trigger="click"
    />
  );
};
